export const METRICS = [
  { value: 40000, suffix: "+", label: "Candidates Mobilized Globally" },
  { value: 20, suffix: "+", label: "Years of Industry Expertise" },
  { value: 11, suffix: "", label: "Industry Verticals Served" },
  { value: 15, suffix: "+", label: "Countries Across 4 Regions" },
];

export const SERVICES = [
  {
    num: "01",
    slug: "global-recruitment",
    title: "Global Recruitment & Talent Acquisition",
    short: "Sourcing skilled, semi-skilled, and professional manpower across industries — delivered from the right regions, on time.",
    full: "We specialize in sourcing and placing skilled, semi-skilled, and professional manpower across industries such as Construction (MEP & Civil), Oil & Gas, Healthcare, Hospitality, Logistics, and more. Our global recruitment network spans the Middle East, Eastern Europe, South Asia, and the Caribbean Islands, allowing us to deliver the right talent from the right regions on time.",
  },
  {
    num: "02",
    slug: "staff-augmentation",
    title: "Staff Augmentation",
    short: "Scale your workforce quickly with flexible deployment models that minimize cost and maximize efficiency.",
    full: "Our staff augmentation services help clients scale their workforce quickly to meet project deadlines or seasonal demand. Whether it's for short-term contracts or long-term assignments, we offer flexible deployment models that minimize cost and maximize efficiency across both technical and non-technical job categories.",
  },
  {
    num: "03",
    slug: "hr-payroll",
    title: "HR & Payroll Management",
    short: "Outsourced HR and payroll — compliance, salary processing, statutory deductions, and taxation handled end-to-end.",
    full: "Vardhamaan provides outsourced HR and payroll services, enabling businesses to focus on core operations while we handle workforce compliance, salary processing, statutory deductions, and taxation. Our solutions are particularly valuable for small to mid-sized firms and international projects requiring lean HR operations.",
  },
  {
    num: "04",
    slug: "visa-immigration",
    title: "Visa, Immigration & Documentation Support",
    short: "Complete backend support for candidate mobilization through our entity Vardhamaan Yanharif — a single point of coordination.",
    full: "Through our entity Vardhamaan Yanharif, we offer complete backend support for candidate mobilization. Our integrated in-house services ensure faster mobilization, reduce third-party dependency, and offer clients a single point of coordination for all deployment needs.",
    features: ["Visa Stamping & Processing", "Immigration Clearance", "MEA Document Attestation", "Medical Testing & Language Training", "In-house Ticketing Services"],
  },
  {
    num: "05",
    slug: "trade-testing",
    title: "Trade Testing & Skill Certification",
    short: "Technical trade tests and assessments to certify blue-collar workers and technicians before deployment.",
    full: "We conduct technical trade tests and assessments to ensure that candidates meet job-specific skill requirements. Our team also coordinates with authorized testing centers to certify blue-collar workers and technicians before deployment.",
  },
  {
    num: "06",
    slug: "executive-search",
    title: "Project-Based Hiring & Executive Search",
    short: "High-caliber leadership talent for specialized roles — customized, confidential, and client-focused.",
    full: "From project managers to engineering heads, we source high-caliber leadership talent for specialized roles in infrastructure, oil & gas, healthcare, and hospitality sectors. Our executive search process is customized, confidential, and client-focused.",
  },
];

export const PROCESS = [
  { days: "01", unit: "Day", title: "Requirement Acknowledged", text: "The request has been acknowledged — we receive and review the client's manpower request and job specifications." },
  { days: "03", unit: "Days", title: "Candidate Evaluation", text: "Careful evaluation of promising applicants through our proprietary database and global network." },
  { days: "07", unit: "Days", title: "Skill Up-gradation", text: "Skill up-gradation of candidates as per the industry — training and briefing to project-specific standards." },
  { days: "07", unit: "Days", title: "Shortlisting & Selection", text: "Narrowing down candidates via technical assessments, trade tests, and client interviews." },
  { days: "04", unit: "Days", title: "Documentation & Compliance", text: "Comprehensive documentation — passport verification, visa processing, attestation, and background checks." },
  { days: "02", unit: "Days", title: "Dispatch & Deployment", text: "In-house ticketing and travel finalized, ensuring timely mobilization to the job site." },
];

export const CATEGORIES = [
  "White-Collar Jobs",
  "Oil & Gas, Petrochemical & Refinery Services",
  "Painting, Insulation & Blasting",
  "MEP (Mechanical, Electrical, Plumbing) & Building Services",
  "Structural, Metal & Fabrication Works",
  "Construction — Civil & Infrastructure",
  "Hospitality & Facilities Management",
  "Rigging, Lifting & Scaffolding",
  "Landscaping & Irrigation",
  "Healthcare & Medical Professionals",
  "Logistics, Material Handling & PMV",
];

export const WHY_US = [
  {
    title: "Top-Rated Manpower Recruiters",
    text: "Registered under the Ministry of External Affairs, Government of India, Vardhamaan Consultancy Services is a fully licensed and ISO-certified organization committed to ethical recruitment practices. Having successfully placed over 40,000 candidates globally, Vardhamaan is a trusted partner to companies seeking efficient and compliant hiring.",
  },
  {
    title: "Extensive Network & Expertise",
    text: "Strong associate partnerships in Nepal, Bangladesh, Sri Lanka, Africa, and Thailand, supported by a pan-India presence and dedicated branch offices in Kuwait and Qatar. Our proprietary database, experienced recruiters, and use of trade tests and internal screenings ensure quality and efficiency.",
  },
  {
    title: "Comprehensive Services",
    text: "Operating under the brand name Vardhamaan Consultancy, Vardhamaan Yanharif extends its expertise beyond recruitment — Visa Stamping, Immigration Clearance, Document Attestation (MEA Work), and In-house Ticketing. By managing all critical backend processes internally, we eliminate delays and maintain full control over quality.",
  },
  {
    title: "Commitment to Excellence",
    text: "We adhere to the highest international standards in recruitment and onboarding. Our rigorous four-step process — sourcing, selection, processing, and deployment — ensures that only the most qualified candidates reach our clients.",
  },
];

export const TEAM = [
  {
    name: "Ulka Salunkhe",
    role: "Director - Finance & Strategic Planning",
    initials: "UL",
    image: "/assets/team-ulka.jpg",
    bio: "Provides strategic leadership across financial management, corporate planning, budgeting, financial reporting, compliance, and resource optimization. Focused on strengthening financial governance, improving operational efficiency, and delivering data-driven insights that support sound decision-making and sustainable long-term growth.",
  },
  {
    name: "Uttam Saragiya",
    role: "Director - Operations & Global Sourcing",
    initials: "US",
    image: "/assets/team-uttam.jpg",
    bio: "Brings extensive expertise in operational management, global sourcing, workforce coordination, and strategic procurement. Drives operational excellence through efficient processes, supplier partnerships, resource optimization, and end-to-end sourcing strategies. His leadership supports seamless execution, cost efficiency, quality standards, and sustainable growth across domestic and international operations.",
  },
  {
    name: "Amol Salunkhe",
    role: "Director - Business Development & Global Growth",
    initials: "AS",
    image: "/assets/team-amol.jpg",
    bio: "A seasoned business development professional with extensive experience across India and international markets. Brings strong expertise in strategic business development, client relationship management, market expansion, partnerships, and revenue growth. Focused on identifying new opportunities, strengthening key business relationships, and driving sustainable growth through strategic market development and client-focused solutions.",
  },
];

export const OFFICES = [
  {
    city: "Mumbai — Head Office",
    country: "India",
    address: "702, Dattani Prism-1, Commercial Premises Cooperative Society Limited, Vasai West, Mumbai, Maharashtra — 401207",
    phone: "+91 84464 97833",
  },
  {
    city: "Ahmedabad",
    country: "India",
    address: "5th Floor, 502 — Vardhaman Yanharif Overseas, Shajanand Complex, Shahibaug, Ahmedabad — 380004",
    phone: "+91 88492 74017",
  },
  {
    city: "Jaipur",
    country: "India",
    address: "Vardhaman Yanharif Overseas, Shiv Shakti Marg, near Civil Line Road, Bokadev Complex, 1st Floor, 101, Jaipur",
    phone: "+91 98282 29230",
  },
  {
    city: "Doha",
    country: "Qatar",
    address: "301, Retaj Tower, Al Jazeera, St. Bin Mahmoud, Doha, Qatar",
    phone: "+974 5562 1384",
  },
];

export const EMAILS = ["amol@vardhamaanconsultancyservices.com", "uttam@vardhamaanconsultancyservices.com"];

export const CLIENTS = [
  "United Precast Concrete", "TTE", "12T", "Rayneau Group of Companies",
  "Construction & Industrial Equipment LLC", "TEMCO", "Technical Experts", "POPL",
  "Global Mechanical Engineering Co. W.L.L.", "NAIB", "Curoscape", "Scientechnic",
  "AGAC — Al Gurg Automation & Controls", "E11 Logistics", "Easa Saleh Al Gurg Group",
  "Leminar Global", "Carisun", "Busbox Investment Inc."
];

export const SOURCE_COUNTRIES = ["India", "Nepal", "Bangladesh", "Sri Lanka", "Thailand", "Africa"];
export const SERVE_REGIONS = ["Qatar", "Kuwait", "Oman", "Bahrain", "Saudi Arabia", "Eastern Europe", "St. Lucia", "Guyana", "Dominica"];

export const CONDUCT = [
  "Adheres to employment laws, human rights principles, and fair labor practices.",
  "Ensures candidates and employees are treated with dignity, respect, and equality.",
  "Does not entertain client requests that violate anti-discrimination regulations.",
  "Provides honest and transparent information regarding candidates' qualifications and experience.",
  "Ensures candidates receive clear, accurate, and complete information about their roles and working conditions.",
  "Prioritizes workplace safety and respects the freedom of candidates to choose employment.",
  "Upholds transparency in all communications and advertisements.",
];

export const ANTI_CORRUPTION = [
  "Zero-tolerance policy towards bribery and corruption.",
  "Conducts business fairly, transparently, and responsibly.",
  "Strictly adheres to anti-bribery and anti-corruption laws and regulations.",
  "Robust systems to detect, prevent, and respond to bribery or corrupt activity.",
  "Applies to all employees, directors, interns, clients, contractors, agency staff, sponsors, consultants, and business associates.",
];

export const MISSION = "To empower businesses and individuals by providing exceptional recruitment and consultancy services. We aim to connect the right talent with the right opportunities, fostering mutual growth and success. Our mission is to build lasting relationships based on trust, integrity, and excellence, ensuring a positive impact on the global job market.";

export const VISION = "To be the leading recruitment and consultancy firm recognized for our unwavering commitment to excellence, innovation, and integrity. We envision a world where every organization can thrive with the right talent, and every individual can achieve their career dreams with the right opportunities.";

export const VALUES = "We are committed to being fair, honest, transparent, and ethical in all our actions — ensuring everything we do stands the test of public scrutiny. We passionately strive for the highest standards of quality, always upholding meritocracy and promoting excellence in every endeavor.";

export const ABOUT_PARAS = [
  "Vardhamaan Consultancy Services is a leading global recruitment and staffing solutions provider with over two decades of industry expertise. Established in the early 2000s, the company has evolved from a small manpower startup into a full-fledged, ISO-certified international organization, offering end-to-end human resource solutions across various industry verticals.",
  "Headquartered in India, with operational branches in Kuwait and Qatar, Vardhamaan has successfully expanded its footprint to serve clients across the Middle East, Eastern Europe, South Asia, and most recently, the Caribbean Islands. We specialize in staffing for sectors such as Construction (MEP & Civil), Oil & Gas, Healthcare, Hospitality, Logistics, and Landscaping & Irrigation — providing both white-collar professionals and blue-collar skilled workers. Over the years, we have mobilized more than 40,000 candidates globally.",
  "What sets Vardhamaan apart is our commitment to quality, compliance, and client-centricity. We provide a full spectrum of services including talent acquisition, staff augmentation, HR and payroll management, visa processing, MEA documentation, immigration support, and in-house ticketing — all under one roof. Our subsidiary, Vardhamaan Yanharif, further strengthens our overseas recruitment operations under the unified brand of Vardhamaan Consultancy.",
  "Whether you are a multinational company seeking skilled manpower or a professional aspiring for global opportunities, Vardhamaan Consultancy Services is your trusted partner in growth and success.",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758518730037-a16581a040e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxyZWNydWl0bWVudCUyMHRlYW0lMjBleGVjdXRpdmUlMjBjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzg3MTE3MzM5fDA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxyZWNydWl0bWVudCUyMHRlYW0lMjBleGVjdXRpdmUlMjBjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzg3MTE3MzM5fDA&ixlib=rb-4.1.0&q=85",
  industrial: "https://images.pexels.com/photos/8730284/pexels-photo-8730284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  interview: "https://images.pexels.com/photos/36733331/pexels-photo-36733331.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const LICENSE = "B-1382/RAJ/PART/300/5/9885/2021";
